import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import women1 from './pictures/women1.jpg';
import women2 from './pictures/women2.JPG';
import women3 from './pictures/women3.jpeg';
import women4 from './pictures/women4.jpeg';
import women5 from './pictures/women5.jpeg';
import women6 from './pictures/women6.jpg';
import women7 from './pictures/women7.JPG';

const Womens = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC International Womens Day Event!</h2>
                    <p class="site-post-meta">March 5th, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>

                    ✨On March 5th, WiC hosted an International Womens Day celebration with students, the Director of the Allen School, faculty, and staff. We discussed the journey of women in computing throughout history, engaged in discussion circles, and collaborated to create a group vision board focused on envisioning the future of women in tech! What a wonderful evening filled with inspirational and meaningful conversations! ✨
                    
                    </p>
                    <img src={women1} alt="pic1 "/>
                    <img src={women2} alt="pic2"/>
                    <img src={women3} alt="pic3"/>
                    <img src={women4} alt="pic4"/>
                    <img src={women5} alt="pic5"/>
                    <img src={women6} alt="pic6"/>
                    <img src={women7} alt="pic7"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Womens;
